import { Request } from "express";

import { IParamBinder } from "./IParamBinder";

export class JsonBodyParamBinder implements IParamBinder {
    public extractValue(req: Request): unknown {
        return req.body;
    }
}
